import type {ContextualMenuGroup} from '@Components/ai-prompt-box/components/ai-prompt-box-footer-actions/ai-prompt-box-contextual-menu/ai-prompt-box-contextual-menu.types';

export interface MenuGroupListProps {
  groups: ContextualMenuGroup[];
  onItemClick: (groupIndex: number, itemIndex: number) => void;
  showItemTooltips?: boolean;
}

export const IMAGE_SIZE_16 = 16;
